// Acceso a la Sala con el contador de pacientes en espera, para pantallas que no usan el menú superior (la ficha del paciente).
import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { useContadorSala } from '@/lib/useContadorSala';

export function BotonSalaEnEspera({ onClick }: { onClick: () => void }): JSX.Element | null {
  const { t } = useTranslation();
  const { disponible, esperando } = useContadorSala();
  if (!disponible) return null;
  return (
    <Button variant="outline" size="sm" onClick={onClick} className="shrink-0">
      {t('dashboard.topnav.sala')}
      {esperando > 0 && (
        <span className="ml-1 grid min-w-5 place-items-center rounded-full bg-hce-clay px-1.5 font-mono text-[11px] text-white" aria-hidden="true">
          {esperando}
        </span>
      )}
      <span className="sr-only">{t('dashboard.topnav.salaEnEspera', { count: esperando })}</span>
    </Button>
  );
}
